import { notification } from "antd";
import Api from "../../api";
import API_URL from "../../api/url";
import { setFaqCategoryDetail, setFaqCategoryList, setFaqDetail, setAbhaCreatedList, setAddattachmentApi } from "../Slices/abhaSlice";

export const abhaCreatedList = (data) => async (dispatch) => {
    try { 
        const res = await Api.post(API_URL.ABHA_CREATED_LIST, data);
        dispatch(setAbhaCreatedList({ list: res.data.result, total: res.data.TotalRecord }));
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const AbhaLinkedNotify = (data, navigate) => async (dispatch) => {
    try {
    
        const res = await Api.post(API_URL.ABHA_LINK_NOTIFY, data );
        // navigate("");
        notification["success"]({
            message: "Record linked Successfully"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const uploadReport = (data, navigate) => async (dispatch) => {
    try {
    
        const res = await Api.post(API_URL.UPLOADREPORT,{customToken: true,...data } );
        navigate("/report-list");
        // window.location.reload();
        notification["success"]({
            message: "Report Added Successfully"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const addattachmentApi = (data) => async (dispatch) => {
    try { 
        const res = await Api.post(API_URL.ABDM_UPLOAD_FILE, data);
        dispatch(setAddattachmentApi({ list: res.data.fileName, total: 0 }));
        notification["success"]({
            message: "File Uploaded successfully"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const updateFaqsApi = (data, id, navigate) => async (dispatch) => {
    try {
        const res = await Api.put(`${API_URL.FAQ_UPDATE}/${id}`, data);
        navigate("/faqs");
        notification["success"]({
            message: "Faq updated successfully!"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const fetchFaqsByIdApi = (data, id) => async (dispatch) => {
    try {
        const res = await Api.post(`${API_URL.FAQ_BY_ID}/${id}`);
        dispatch(setFaqDetail(res.data.Data));
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const fetchFaqCategoryApi = (data) => async (dispatch) => {
    try {
        const res = await Api.get(API_URL.FAQ_CATEGORY_LIST, { params: data });
        dispatch(setFaqCategoryList({ list: res.data.Data, total: res.data.TotalRecord }));
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const addFaqCategoryApi = (data, navigate) => async (dispatch) => {
    try {
        const res = await Api.post(API_URL.FAQ_CATEGORY_ADD, data);
        navigate("/faq-category");
        notification["success"]({
            message: "Faq Category created successfully!"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const updateFaqCategoryApi = (data, id, navigate) => async (dispatch) => {
    try {
        const res = await Api.put(`${API_URL.FAQ_CATEGORY_UPDATE}/${id}`, data);
        navigate("/faq-category");
        notification["success"]({
            message: "Faq Category updated successfully!"
        });
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};
export const fetchFaqCategoryByIdApi = (data, id) => async (dispatch) => {
    try {
        const res = await Api.post(`${API_URL.FAQ_CATEGORY_BY_ID}/${id}`);
        dispatch(setFaqCategoryDetail(res.data.Data));
        return res;
    } catch (error) {
        notification["error"]({
            message: error.response?.data?.message || error.message
        });
        return error
    }
};